import useChooserResponse from '@/hooks/useChooserResponse';
import PresetFeedScreen from '../PresetFeedScreen';

const MobileCreate = () => {
  useChooserResponse();

  return <PresetFeedScreen />;
};

export default MobileCreate;
